const maxVisibleOptions = 5;

export const getDisplayText = (options: string[]) => {
  if (options.length === 0) return '';

  const visibleOptions = options.slice(0, maxVisibleOptions);
  let displayText = visibleOptions.join(', ');

  if (options.length > maxVisibleOptions) {
    const lastOption = visibleOptions[visibleOptions.length - 1];
    const truncatedLastOption =
      lastOption.length > 3 ? lastOption.slice(0, -3) + '...' : '...';

    visibleOptions[visibleOptions.length - 1] = truncatedLastOption;
    displayText = visibleOptions.join(', ');
  }

  return displayText;
};
